module.exports = __webpack_public_path__ + "static/media/potato.a48fb470.png";